import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { NetworkIndicatorComponent } from './network-indicator.component';

@NgModule({
    declarations: [
        NetworkIndicatorComponent
    ],
    imports: [
        CommonModule,
        TooltipModule,
        DialogModule,
        ButtonModule
    ],
    exports: [
        NetworkIndicatorComponent
    ]
})
export class SharedNetworkIndicatorModule { }
